<template>
    <div class="addByFhd table-bg" v-loading="loading">
        <el-row :gutter="20">
            <el-col :span="4" style="text-align: right">
                发货单:
            </el-col>
            <el-col :span="20">
                <el-input placeholder="请选择发货单" v-model="form.pcb_number" style="width: 50%">
                    <el-button slot="append" class="iconfont icon009" @click="chooseFhd"></el-button>
                </el-input>
            </el-col>
        </el-row>
        <el-row :gutter="20" style="margin-top: 0.2rem">
            <el-col :span="4" style="text-align: right">
                试块组:
            </el-col>
            <el-col :span="20">
                <div class="test-block">
                    <div class="block-info" v-if="testBlockSampleList.length>0">
                        <div
                            class="info-item"
                            v-for="item in testBlockSampleList"
                            :key="item.test_block_type"
                            @click="selectTestBlock(item)"
                        >
                            <label :class="{active:item.is_confirm}">
                                <i class="iconfont iconduigou"></i>
                                <span>{{ item.test_block_type_name }}</span>
                            </label>
                            <span>{{ item.sample_group_amount_name }}-{{ item.test_block_amount_name }}</span>
                        </div>
                    </div>
                    <div class="block-set-btn" @click="openSet">
                        设置
                    </div>
                </div>
            </el-col>
        </el-row>
        <el-row :gutter="20" style="margin-top: 0.2rem">
            <el-col :span="4" style="text-align: right">
                取样时间:
            </el-col>
            <el-col :span="20">
                <el-date-picker
                    v-model="form.sampling_time"
                    type="datetime"
                    placeholder="选择日期"
                    value-format="yyyy-MM-dd HH:mm:ss"
                >
                </el-date-picker>
            </el-col>
        </el-row>
        <div class="ratioBlockSampleSetPop" v-if="showBlockSampleSetPop">
            <div class="popClose" @click="showBlockSampleSetPop=false">
                关闭
            </div>
            <ratioBlockSampleSet :task-number="task_number" @updateType="updateBlockSampleList"></ratioBlockSampleSet>
        </div>
        <footer>
            <el-button
                type="primary"
                class="save"
                @click="save"
            >
                保存
            </el-button>
            <el-button
                class="Close"
                @click="cancel"
            >
                取消
            </el-button>
        </footer>
    </div>
</template>

<script>
export default {
    name: 'add-by-fhd',
    props: {
        extr: Object,
    },
    data() {
        return {
            loading: false,
            form: {
                pcb_number: '',
                task_number: '',
                list: [],
                sampling_time: '',
            },
            testBlockSampleList: [],
            showBlockSampleSetPop: false,
        };
    },
    methods: {
        // 保存
        async save() {
            if (!this.form.pcb_number) {
                this.$message.warning('请选择发货单');
                return;
            }
            this.form.list = this.testBlockSampleList.filter(item => {
                item.task_number = this.form.task_number;
                const b = item.is_confirm;
                if (b) {
                    delete item.is_confirm;
                }
                return Boolean(b);
            });
            if (this.form.list.length === 0) {
                this.$message.warning('请选择试块组');
                return;
            }
            if (this.form.sampling_time === '') {
                this.$message.warning('请选择取样时间');
                return;
            }
            try {
                this.loading = true;
                await this.$axios.$post('/interfaceApi/production/testblock/manually_create_test_block_sample', this.form);
                this.$message.success('保存成功');
                this.loading = false;
                window.updateTable();
                this.$parent.hide();
            } catch (e) {
                if (e.ErrorCode) {
                    this.$message.error(e.ErrorCode.Message);
                }
                this.loading = false;
            }
        },
        // 选中取消选择试块
        selectTestBlock(item) {
            item.is_confirm = Number(!item.is_confirm);
        },
        // 根据任务获取配留样配置组合信息(文本)
        getTestBlockSampleList() {
            this.$axios.$get('/interfaceApi/production/testblock/manually/get_setup_working_list?task_number=' + this.form.task_number)
                .then(res => {
                    // eslint-disable-next-line no-return-assign
                    this.testBlockSampleList = res.map(item => {
                        item.is_confirm = 0;
                        return item;
                    });
                });
        },
        // 选择发货单
        async chooseFhd() {
            this.$toast({
                title: true,
                text: '添加发货单',
                type: 'eject',
                width: '60%',
                height: '70%',
                t_url: 'tableList/index',
                extr: {
                    code: {
                        TableCode: 'test_block_sample_choose_pcb',
                        sureCallback: this.chooseFhdBack,
                    },
                },
            });
        },
        chooseFhdBack(data) {
            this.form.pcb_number = data.pcb_number;
            this.form.task_number = data.task_number;
            this.form.sampling_time = data.product_complete_time;
            this.getTestBlockSampleList();
        },
        openSet() {
            this.$toast({
                title: true,
                text: '设置',
                type: 'eject',
                width: '70%',
                height: '80%',
                t_url: 'technicalQualityManage/testBlockSample/testBlock/testBlockSet',
                extr: {
                    settings: this.testBlockSampleList,
                    taskNumber: this.form.task_number,
                    updateSetFunc: this.updateSetFunc,
                },
            });
        },
        // 更新设置
        updateSetFunc(data) {
            const obj = {
                id: '',
                test_block_specs: data.test_block_specs,
                test_block_specs_name: data.test_block_specs_name,
                test_block_age: data.test_block_age,
                test_block_age_name: data.test_block_age_name,
                sample_group_amount: data.sample_group_amount,
                sample_group_amount_name: data.sample_group_amount_name,
                test_block_amount: data.test_block_amount,
                test_block_amount_name: data.test_block_amount_name,
                test_block_type: data.test_block_type,
                test_block_type_name: data.test_block_type_name,
                task_number: data.task_number,
                is_complete: null,
                is_confirm: 0,
                loop_num: null,
                code_alias_name: null,
            };
            const targetIndex = this.testBlockSampleList.findIndex(o => o.test_block_type === obj.test_block_type);
            if (data.is_enable === 1) {
                if (targetIndex !== -1) {
                    this.testBlockSampleList.splice(targetIndex, 1, obj);
                } else {
                    this.testBlockSampleList.push(obj);
                    this.testBlockSampleList.sort((a, b) => {
                        return a.test_block_type - b.test_block_type;
                    });
                }
            } else if (targetIndex !== -1) {
                this.testBlockSampleList.splice(targetIndex, 1);
            }
        },
        // 取消
        cancel() {
            this.$parent.hide();
        },
    },
};
</script>

<style lang="stylus" scoped>
.addByFhd
    width 100%
    height 100%
    padding 20px
    background #fff
    position relative
    font-size 16px
    .test-block
        display flex
        align-items center
        max-width 900px
        padding-right: 30px
        .block-info
            display flex
            align-items center
            flex-wrap wrap
            margin 0 10px
            .info-item
                font-size 13px
                background rgba(42, 170, 221, 0.08)
                white-space nowrap
                line-height 22px;
                cursor pointer
                label
                    padding 1px 4px
                    background #2AAADD
                    position relative
                    color #fff;
                    &:after
                        position absolute
                        right -8px
                        top 6px
                        display inline-block
                        width 0
                        height 0
                        content ''
                        border-width 4px
                        border-style solid
                        border-color transparent transparent  transparent #2AAADD
                    .iconduigou
                        background #fff
                        font-size 10px
                        vertical-align top
                    &.active
                        .iconduigou
                            color #fa6400
                span
                    margin-left 3px
                    padding 1px 2px
        .block-set-btn
            display inline-block
            padding 2px 8px
            line-height 22px
            background: #FA6400;
            border-radius: 4px;
            font-size 14px
            color #fff
            white-space nowrap
            cursor pointer
    .ratioBlockSampleSetPop
        width 80%
        height 80%
        box-shadow: 0rem 2px 60px 0rem rgba(0, 0, 0, 0.7);
        position absolute
        right 0
        bottom 0
        z-index 9
        .popClose
            position absolute
            right 20px
            top 20px
            z-index 99
            display flex
            justify-content center
            align-items center
            width: 70px
            height: 32px
            border-radius: 2px
            border: 1px solid #1577D2
            font-size 16px
            color #1577D2
            cursor pointer
    .sandRateBtn
        background: linear-gradient(270deg, #FD9D00 0%, #FA6400 100%);
        border 0
    >>> .el-input__suffix
        display flex
        align-items center
        font-size 16px
    footer
        position absolute
        bottom 20px
        width 100%
        height 50px
        display flex
        justify-content center
        align-items center
        button
            width 150px
            height 40px
            font 16px '微软雅黑'
            margin 0 15px
            border none
            cursor pointer
            display flex
            justify-content center
            align-items center
            &.save
                color #fff
                background #1577D2
            &.Close
                color #1577D2
                background #fff
                border 1px solid #1577D2
</style>
